// import React from 'react';
// import './EquipmentSection.css';

// const brands = [
//   { name: 'Hammer Strength', category: 'Strength Training', icon: '🏋️' },
//   { name: 'Hoist', category: 'Selectorized & Cable', icon: '💪' },
//   { name: 'Life Fitness', category: 'Cardio & Strength', icon: '🔄' },
//   { name: 'FreeMotion', category: 'Cable & Functional', icon: '⚡' },
//   { name: 'Paramount', category: 'Multi-Station', icon: '🏆' },
//   { name: 'Assault Fitness', category: 'HIIT & Conditioning', icon: '🚀' },
//   { name: 'Bose Music', category: 'Premium Audio System', icon: '🎵' },
// ];

// export default function EquipmentSection() {
//   return (
//     <section id="equipment" className="equipment-section">
//       <div className="container">
//         <div className="equipment-header">
//           <div>
//             <p className="section-label">World-Class Gear</p>
//             <h2 className="section-title">
//               Our <span>Equipment</span>
//             </h2>
//             <div className="divider" />
//             <p className="equipment-desc">
//               Every piece of equipment at Gym Arena is sourced from the world's most trusted
//               fitness brands — ensuring quality, safety, and performance at every rep.
//             </p>
//           </div>
//           <div className="equipment-area-card">
//             <span className="equipment-area-num">8,500</span>
//             <span className="equipment-area-label">Square Feet</span>
//             <span className="equipment-area-sub">of premium fitness space</span>
//           </div>
//         </div>

//         <div className="brands-grid">
//           {brands.map((brand, i) => (
//             <div className="brand-card" key={i}>
//               <div className="brand-card__icon">{brand.icon}</div>
//               <div>
//                 <h3 className="brand-card__name">{brand.name}</h3>
//                 <p className="brand-card__category">{brand.category}</p>
//               </div>
//               <div className="brand-card__badge">Partner</div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// }


// import React from 'react';
// import './EquipmentSection.css';
// import { motion } from 'framer-motion';

// const brands = [
//   { name: 'Hammer Strength', category: 'Strength Training', icon: '🏋️', link: 'https://www.lifefitness.com/en-us/catalog/strength-training/plate-loaded/hammer-strength' },
//   { name: 'Hoist', category: 'Selectorized & Cable', icon: '💪', link: 'https://www.hoistfitness.com/' },
//   { name: 'Life Fitness', category: 'Cardio & Strength', icon: '🔄', link: 'https://www.lifefitness.com/' },
//   { name: 'FreeMotion', category: 'Cable & Functional', icon: '⚡', link: 'https://www.freemotionfitness.com/' },
//   { name: 'Paramount', category: 'Multi-Station', icon: '🏆', link: 'https://paramountfitness.com/' },
//   { name: 'Assault Fitness', category: 'HIIT & Conditioning', icon: '🚀', link: 'https://www.assaultfitness.com/' },
//   { name: 'Bose Music', category: 'Premium Audio System', icon: '🎵', link: 'https://www.bose.com/' },
// ];

// export default function EquipmentSection() {

//   // 🔥 Stagger animation container
//   const container = {
//     hidden: {},
//     show: {
//       transition: {
//         staggerChildren: 0.15,
//       },
//     },
//   };

//   // 🔥 Individual card animation
//   const item = {
//     hidden: { opacity: 0, y: 40 },
//     show: { opacity: 1, y: 0 },
//   };

//   return (
//     <section id="equipment" className="equipment-section">
//       <div className="container">

//         {/* HEADER */}
//         <div className="equipment-header">
//           <div>
//             <p className="section-label">World-Class Gear</p>

//             <h2 className="section-title">
//               Our <span>Equipment</span>
//             </h2>

//             <div className="divider" />

//             <p className="equipment-desc">
//               Every piece of equipment at Gym Arena is sourced from the world's most trusted
//               fitness brands — ensuring quality, safety, and performance at every rep.
//             </p>
//           </div>

//           <div className="equipment-area-card">
//             <span className="equipment-area-num">8,500</span>
//             <span className="equipment-area-label">Square Feet</span>
//             <span className="equipment-area-sub">of premium fitness space</span>
//           </div>
//         </div>

//         {/* 🔥 GRID WITH ANIMATION */}
//         <motion.div
//           className="brands-grid"
//           variants={container}
//           initial="hidden"
//           whileInView="show"
//         //   viewport={{ once: true }}
//           viewport={{ once: false, amount: 0.2 }}
//         >
//           {brands.map((brand, i) => (
//             <motion.a
//               key={i}
//               href={brand.link}
//               target="_blank"
//               rel="noopener noreferrer"
//               className="brand-card"
//               variants={item}

//               // 🔥 Hover animation
//               whileHover={{ y: -8, scale: 1.03 }}
//               whileTap={{ scale: 0.97 }}
//             >
//               <div className="brand-card__icon">{brand.icon}</div>

//               <div>
//                 <h3 className="brand-card__name">{brand.name}</h3>
//                 <p className="brand-card__category">{brand.category}</p>
//               </div>

//               <div className="brand-card__badge">Partner</div>
//             </motion.a>
//           ))}
//         </motion.div>

//       </div>
//     </section>
//   );
// }




import React from 'react';
import './EquipmentSection.css';
import { motion } from 'framer-motion';

const brands = [
  { name: 'Hammer Strength', category: 'Strength Training', icon: '🏋️', link: 'https://www.lifefitness.com/en-us/catalog/strength-training/plate-loaded/hammer-strength' },
  { name: 'Hoist', category: 'Selectorized & Cable', icon: '💪', link: 'https://www.hoistfitness.com/' },
  { name: 'Life Fitness', category: 'Cardio & Strength', icon: '🔄', link: 'https://www.lifefitness.com/' },
  { name: 'FreeMotion', category: 'Cable & Functional', icon: '⚡', link: 'https://www.freemotionfitness.com/' },
  { name: 'Paramount', category: 'Multi-Station', icon: '🏆', link: 'https://paramountfitness.com/' },
  { name: 'Assault Fitness', category: 'HIIT & Conditioning', icon: '🚀', link: 'https://www.assaultfitness.com/' },
  { name: 'Bose Music', category: 'Premium Audio System', icon: '🎵', link: 'https://www.bose.com/' },
];

export default function EquipmentSection() {

  // 🔥 TEXT animation (like About section)
  const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    show: { opacity: 1, y: 0 }
  };

  // 🔥 Stagger for cards
  const container = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 40 },
    show: { opacity: 1, y: 0 },
  };

  return (
    <section id="equipment" className="equipment-section">
      <div className="container">

        {/* 🔥 HEADER (NOW ANIMATED) */}
        <div className="equipment-header">

          <div>

            <motion.p
              className="section-label"
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: false, amount: 0.2 }}
              transition={{ duration: 0.5 }}
            >
              World-Class Gear
            </motion.p>

            <motion.h2
              className="section-title"
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: false, amount: 0.2 }}
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              Our <span>Equipment</span>
            </motion.h2>

            <motion.div
              className="divider"
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: false, amount: 0.2 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            />

            <motion.p
              className="equipment-desc"
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: false, amount: 0.2 }}
              transition={{ duration: 0.5, delay: 0.3 }}
            >
              Every piece of equipment at Gym Arenaa is sourced from the world's most trusted
              fitness brands — ensuring quality, safety, and performance at every rep.
            </motion.p>

          </div>

          {/* 🔥 RIGHT CARD ANIMATION */}
          <motion.div
            className="equipment-area-card"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: false, amount: 0.2 }}
            transition={{ duration: 0.5, delay: 0.4 }}
          >
            <span className="equipment-area-num">8,500</span>
            <span className="equipment-area-label">Square Feet</span>
            <span className="equipment-area-sub">of premium fitness space</span>
          </motion.div>

        </div>

        {/* 🔥 GRID */}
        <motion.div
          className="brands-grid"
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0.2 }}
        >
          {brands.map((brand, i) => (
            <motion.a
              key={i}
              href={brand.link}
              target="_blank"
              rel="noopener noreferrer"
              className="brand-card"
              variants={item}
              whileHover={{ y: -8, scale: 1.03 }}
              whileTap={{ scale: 0.97 }}
            >
              <div className="brand-card__icon">{brand.icon}</div>

              <div>
                <h3 className="brand-card__name">{brand.name}</h3>
                <p className="brand-card__category">{brand.category}</p>
              </div>

              <div className="brand-card__badge">Partner</div>
            </motion.a>
          ))}
        </motion.div>

      </div>
    </section>
  );
}